import {Utils} from '@exp1/front-utils'
import {Params, Responses} from 'commonTypes/products'
import {axiosInstance} from './getInstance'

export const crudApi = new Utils.CrudApi<never, Params.Update, Responses.List, Responses.Item, never, Responses.Update>(
  '/api/app/products',
  axiosInstance
)
